module.exports = __webpack_public_path__ + "media/icons/link-d5acd8d8.svg";